module.exports = __webpack_public_path__ + "img/GreatAndBeautifulGoldenEmpress_DG.a457503e.jpg";